import { gql } from '@apollo/client';

const updateListingStateMutation = gql`
  mutation Core_Listing_UpdateState(
    $input: Input_core_apimessages_UpdateListingStateRequest
  ) {
    updateListingState(input: $input) {
      newState
    }
  }
`;

export default updateListingStateMutation;
